// components/PageViewLogger.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid';
import { getSessionId } from '../utility/commonFunctions';

const PageViewLogger = () => {
  const location = useLocation();

  useEffect(() => {
    const sendPageViewToNewRelic = () => {
      if (window.newrelic) {
        window.newrelic.addPageAction("PageViewEvents", {
          path: location.pathname,
          search: location.search,
          timestamp: new Date().toISOString(),
          sessionId: getSessionId()
        });
         // For debugging:
        console.log("Page viewed:", location.pathname + location.search,"sessionId:", getSessionId());
      } else {
        console.warn("New Relic not available on window");
      }
    };

    sendPageViewToNewRelic();
  }, [location]);

  return null;
};

export default PageViewLogger;
